<template>
<div class="container">
    <div class="row d-flex mb-4 justify-content-end">
        <div class="col-8">
            <h3 class="c-ndarkthree bold">
                <Groups :color="getPrimaryColorHex.four" class="mr-0"/> Grupos econômicos
            </h3>
            <p class="c-ndarkfour">
                Visualize todos os grupos econômicos da plataforma.
            </p>
        </div>
        <div class="col-4 d-flex align-items-end justify-content-end">
            <Button @click="group()" :color="getPrimaryColor">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.99983 1V9M1 5H8.99967" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Novo grupo econômico
            </Button>
        </div>
        <div class="col-12 mt-4 pt-3 d-flex align-items-center justify-content-end">
            <div class="ml-2">
                <el-input  @keyup.native.enter="filterSearchQuery" placeholder="Buscar" v-model="filterSearch"  :class="`${getPrimaryColor} filter`" clearable>
                    <button class="btn" slot="append" @click="filterSearchQuery">
                        <SearchIcon class="mx-0" size="16" />
                    </button>
                </el-input>
                <h6 slot="append" class="regular">
                    Busque pelo nome do grupo. Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
                </h6>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <TableLoading v-if="isLoading" rowHeight="56" class="mt-3"/>
            <BusinessGroup v-else-if="businessGroupData.length" :tableData="businessGroupData" @groupDeleted="getAllGroups" @persistFilter="persistFilter"/>
            <NotFound v-else-if="search.length"/>
            <Empty
                title="Nenhum grupo econômico associado!"
                v-else
            >
                Por enquanto, não há grupos econômicos associados.
            </Empty>
            <PaginationButtons :pagination="$store.state.group.groupsPagination" @next="paginationNextAndPrev($event)" @prev="paginationNextAndPrev($event)"/> 
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading"/>
</div>
</template>

<script>
import PaginationButtons from '@/components/pagination/PaginationButtons'
import BusinessGroup from '@/components/tables/BusinessGroup'
import getAllEconomicGroups from '@/api/getAllEconomicGroups'
import Groups from '@/components/icons/Groups'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import Empty from '@/components/emptyOrNotFound/EmptyEconomicGroup'
import FullLoading from '@/components/loading/FullLoading'
import TableLoading from '@/components/loading/TableLoading'
import store from '@/store'

export default {
    components: {
        PaginationButtons,
        BusinessGroup,
        Groups,
        NotFound,
        FullLoading,
        TableLoading,
        Empty,
    },
    data() {
        return {
            filterSearch: '',
            search: '',
            businessGroupData: [],
            isLoading: false,
            page: 1,
        }
    },
    computed: {
        filteredBusinessGroupData() {
            if (this.businessGroupData.length) {
                return this.businessGroupData.filter(group => group.name.toLowerCase().includes(this.search.toLowerCase()))
            } else {
                return []
            }
        }
    },
    watch: {
        filterSearch(val) {
            if (!val.length) {
                this.filterSearchQuery()
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        store.commit('filters/setBeforePathEnter', from.path)
        next();
    },
    methods: {
        persistFilter(){
            this.$store.commit('filters/setPersistentFilterQuery', this.filterSearch)
        },
        filterSearchQuery() {
            this.search = this.filterSearch
            this.getAllGroups()
        },
        async paginationNextAndPrev(page) {
            this.page = page
            this.isLoading = true
            const result = await getAllEconomicGroups({ page, query: this.filterSearch, withBuyer: 1, withEconomicGroupRule: 1 })
            this.isLoading = false
            this.businessGroupData = result.data.payload.rows
        },
        async getAllGroups() {
            this.isLoading = true
            const result = await getAllEconomicGroups({ page: '1', query: this.filterSearch, withBuyer: 1, withEconomicGroupRule: 1 })
            this.isLoading = false
            this.businessGroupData = result.data.payload.rows
        },
        group() {
            this.$router.push('/group/new')
        }
    },
    created() {
        const { state: { 
                filters: { persistentFilterQuery, beforePathEnter },
        } } = this.$store
        const updateGropup = "/group/"
        const cameFromUpdate = (beforePathEnter.includes(updateGropup))

        if (cameFromUpdate) {
            this.filterSearch = persistentFilterQuery
            this.search = persistentFilterQuery
        } else {
            this.$store.commit('filters/setPersistentFilterQuery', '')
        }
        this.getAllGroups()
    }
}
</script>

<style lang="scss" scoped>

</style>
